module.exports = __webpack_public_path__ + "static/media/man.599fa6cc.jpg";